import ImpactReferenceSelector, {
  ImpactReferenceSelectedContentProps,
} from "@/components/ImpactReferenceSelector/ImpactReferenceSelector";
import useAnalytics from "@/hooks/useAnalytics";
import { ImpactDataset } from "@/hooks/useEcoInventDatasets";
import useTranslation from "@/hooks/useTranslation";
import { message } from "antd";
import { useState } from "react";
import { useGetGoodsAndServicesItem, usePatchGoodsAndServicesItem } from "../useGoodsAndServices";

export default function GoodsAndServicesItemImpact({
  goodsAndServicesItemId,
}: {
  goodsAndServicesItemId: number;
}) {
  const { data: goodsAndServicesItem, isLoading } = useGetGoodsAndServicesItem({
    goodsAndServicesItemId,
  });

  const [selectedDataset, setSelectedDataset] = useState<ImpactDataset>();
  const patchGoodsAndServicesItem = usePatchGoodsAndServicesItem();

  const analytics = useAnalytics();
  const translation = useTranslation();

  const onSubmit = () => {
    if (selectedDataset) {
      return patchGoodsAndServicesItem
        .mutateAsync({
          goodsAndServicesItemId,
          patch: {
            impact_dataset_id: selectedDataset.id,
          },
        })
        .then(() => {
          analytics.track(`Impact Reference Updated`);
        })
        .catch(() => {
          message.error(translation.errors.general);
        });
    }
  };

  const onDelete = () =>
    patchGoodsAndServicesItem
      .mutateAsync({
        goodsAndServicesItemId,
        patch: {
          clear: ["impact_dataset_id"],
        },
      })
      .then(() => {
        analytics.track("Impact Reference Deleted");
      })
      .catch(() => {
        message.error(translation.errors.general);
      });

  const selectedContent: ImpactReferenceSelectedContentProps = {
    type: "goods_and_services_item",
    name: goodsAndServicesItem?.name || "",
  };

  const onDatasetChange = (dataset?: ImpactDataset) => {
    setSelectedDataset(dataset);
  };

  const loadingStates = {
    data: isLoading,
    onDatasetConfirm: patchGoodsAndServicesItem.isLoading,
  };

  return (
    <ImpactReferenceSelector
      includeExioBase={true}
      confirmedDataset={goodsAndServicesItem?.impact_dataset || undefined}
      selectedDataset={selectedDataset}
      onDatasetChange={onDatasetChange}
      loading={loadingStates}
      modalTitle={"Edit impact reference"}
      showIncomplete={true}
      onDatasetConfirm={onSubmit}
      onDelete={onDelete}
      defaultDatabaseFilter={{ special_activity_type: ["market activity", "market group"] }}
      selectedContent={selectedContent}
      defaultTab={"exiobase"}
    />
  );
}
